import { render } from "./manage-edit-category-wod.vue?vue&type=template&id=6dd5453a"
import script from "./manage-edit-category-wod.vue?vue&type=script&lang=js"
export * from "./manage-edit-category-wod.vue?vue&type=script&lang=js"
script.render = render

export default script